export const HelpOrchestratorStates = {
    IDLE: 'IDLE',
    APPOINTMENT: 'APPOINTMENT',
    FORM: 'FORM',
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
} as const;

export type HelpOrchestratorState = typeof HelpOrchestratorStates[keyof typeof HelpOrchestratorStates];
